



























































































import VueElementLoading from "vue-element-loading"
import VueDraggable from 'vuedraggable'
import { Vue, Component, Prop } from 'vue-property-decorator'
import { ReportMBSPRow } from "../table-data/ReportMBSPRow"
import { Classificator } from "../../../common/types/Classificator"
import { Indicator } from "../../../common/types/Indicator"
import { ClassificationType } from "../../../common/types/roots/fields"
import { formatDigitsGrouping, padLeadingZeros } from "../../../common/utils/formattingUtils"
import { cloneDeep } from "lodash"
import moment from "moment"

type Column = keyof ReportMBSPRow

interface TableField {
    key: Column
    active: boolean
}

interface ParentIndicator {
    key: string
    colspan: number
    rowspan: number
}

@Component({
    components: {
        'draggable': VueDraggable,
        'loading': VueElementLoading
    }
})
export default class ReportMBSP extends Vue {

    @Prop({
        type: Array,
        required: true,
        default: [],
    })
    public readonly tableData!: ReportMBSPRow[]

    @Prop({
        type: Array,
        required: true,
        default: [],
    })
    private readonly propIndicators!: Indicator[]

    @Prop({
        type: Date,
        required: true,
        default: new Date(),
    })
    private readonly date!: Date


    public tableFields: TableField[] = []
    public indicators: Indicator[] = []

    public currentPage = 1
    public perPage = 30
    public get visibleRows() {
        return this.tableData.filter(it => it.visible).length
    }
    public get currentItems(): ReportMBSPRow[] {
        const indexedPage = this.currentPage - 1
        const startIndex = indexedPage * this.perPage
        const endIndex = startIndex + this.perPage
        return this.tableData.filter(it => it.visible).slice(startIndex, endIndex)
    }

    private created() {
        this.indicators = cloneDeep(this.propIndicators)
        this.constructTableFields(true)
        this.handlePageChange(1)
        this.$watch('tableData', () => {
            this.constructTableFields(true)
        }, {deep: true})
    }

    private constructTableFields(isOnCreate: boolean) {
        const tableFields: TableField[] = []
        const indicators = cloneDeep(isOnCreate ? this.propIndicators : this.indicators)
        indicators.filter(it => it.active).forEach(indicator => {
            tableFields.push({ key: (indicator.key as any), active: true })
        })

        this.tableFields = tableFields
    }

    public handlePageChange(page: number) {
        this.currentPage = page
    }

    public tr(key: any): string | null {
        if (typeof key !== 'string') {
            return null
        }

        let text = ''
        let tableTranslationKey = ''
        tableTranslationKey = 'modules.budget_execution_monitoring.reports_constructor.mbsp'
        text = String(this.$t(`${tableTranslationKey}.${key}`))

        if (!text || text === `${tableTranslationKey}.${key}`) {

            const translationKey = 'modules.budget_execution_monitoring.reports_constructor'
            text = String(this.$t(`${translationKey}.${key}`))

            if (!text || text === `${translationKey}.${key}`) {
                text = key
            }
        }
        return text
    }

    public synchronizeIndicatorsOrder() {
        // const fullIndicatorKeys = this.indicatorKeys.filter(it => ['plgp', 'plgo'].notIncludes(it)).concat(['plgs'])
        // const indicatorsOrder = this.tableFields
        //     .filter(it => fullIndicatorKeys.includes(it.key))
        //     .map(it => it.key)

        //     fullIndicatorKeys.forEach(indicatorKey => {
        //     if (indicatorsOrder.notIncludes(indicatorKey)) {
        //         indicatorsOrder.push(indicatorKey)
        //     }
        // })

        // const tempIndicators: Indicator[] = []
        // indicatorsOrder.forEach(indicatorKey => {
        //     const IndicatorObject = this.indicators.find(it => it.key === indicatorKey)!
        //     tempIndicators.push(IndicatorObject)
        // })

        // this.indicators = tempIndicators
        // this.$emit('update-indicators', tempIndicators)
    }

    public synchronizeVisiblityInTable() {
        this.$emit('update-indicators', cloneDeep(this.indicators))
        this.constructTableFields(false)
    }
    public get getIndicators() {
        return this.indicators.slice(0, 5)
    }
    public format(value: any): any {
        if (value == null) {
            return ''
        }
        if (Number(value).isNaN) {
            return value
        }
        return formatDigitsGrouping(value)
    }

    public tableCollapse = false
    public collapse(idx:number, collapse:boolean, collapseAll:boolean = false) {
        const el:ReportMBSPRow = this.tableData[idx]
        if (el.hasChild) {
            for (const ch of this.tableData.slice(idx + 1)) {
                if (ch.parent_idx === idx) {
                    ch.visible = !collapse
                    if (collapse || collapseAll) {
                        this.collapse(ch['idx'], collapse, collapseAll)
                        ch.collapse = collapse
                    }
                }

            }
        }
        el.collapse = collapse
    }
    public collapseAll(collapse:boolean) {
        for (const item of this.tableData) {
            if (item.parent_idx === null && item.hasChild) {
                item.collapse = collapse
                this.collapse(item.idx, collapse, true)
            }
        }
        this.tableCollapse = collapse
    }
}
